import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SimpleBar from 'simplebar-react';

const SideBar = ({ handleToggle, toggled, setHovered }) => {

    return (
        <>
            <div className="sidebar-wrapper" data-simplebar="true"
                onMouseEnter={() => toggled && setHovered(true)}
                onMouseLeave={() => toggled && setHovered(false)}>
                <div className="sidebar-header">
                    <div>
                        <img src="images/logo.png" className="logo-icon logo_dark" alt="logo icon" />
                        <img src="images/logo-light.png" className="logo-icon logo_light" alt="logo icon" />
                        <img src="images/favicon-32x32.png" className="sml_logo" alt="logo icon" />
                    </div>
                    <div className="toggle-icon ms-auto" onClick={handleToggle}><i className="bx bx-menu" /></div>
                </div>
                <SimpleBar style={{ maxHeight: "100%" }}>
                    <ul className="metismenu" id="menu">
                        <li>
                            <Link to="/">
                                <div className="parent-icon"><i className="bx bx-home" /></div>
                                <div className="menu-title">Dashboard</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/club-management">
                                <div className="parent-icon"><i className="bx bx-building-house" /></div>
                                <div className="menu-title">Club Management</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/referee-management">
                                <div className="parent-icon"><i className="bx bx-user-check" /></div>
                                <div className="menu-title">Referee Management</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/coach-management">
                                <div className="parent-icon"><i className="bx bx-user-check" /></div>
                                <div className="menu-title">Coach Management</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/game-management">
                                <div className="parent-icon"><i className="bx bx-baseball" /></div>
                                <div className="menu-title">Games Management</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/team-management">
                                <div className="parent-icon"><i className="bx bx-user" /></div>
                                <div className="menu-title">Teams Management</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/finances">
                                <div className="parent-icon"><i className="bx bx-credit-card" /></div>
                                <div className="menu-title">Payments</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/roles-management">
                                <div className="parent-icon"><i className="bx bx-book" /></div>
                                <div className="menu-title">Role Management</div>
                            </Link>
                        </li>
                        <li>
                            <Link to="/setting">
                                <div className="parent-icon"><i className="bx bx-cog" /></div>
                                <div className="menu-title">Settings</div>
                            </Link>
                        </li>
                    </ul>
                </SimpleBar>
                <div className="sidebar-logout">
                    <ul>
                        <li>
                            <Link to="javascript:;" data-bs-toggle="modal" data-bs-target="#logout_modal"
                                className="d-flex align-content-center">
                                <div className="parent-icon"><i className="bx bx-log-out" /></div>
                                <div className="menu-title">Logout</div>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default SideBar